import {createApp} from 'vue'
import OpretHoldOverlay from './OpretHoldOverlay'

const el = '[data-content=OpretHoldOverlay]'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((OpretHoldOverlayDOM)=>{
            const stafetkode = OpretHoldOverlayDOM.dataset.stafetkode
            const createHoldUrl = OpretHoldOverlayDOM.dataset.createHoldUrl

            Store.commit('stafet/set_stafet_id', stafetkode)
            Store.commit('main/set_page_overlay_content_data', {createHoldUrl})
        })
    }
}